module.exports = __webpack_public_path__ + "img/cleaning.ea6d6e4a.svg";